// Libs
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
// App
import { CATALOG_SHOPS_URL } from '../../shop.constants';
import { AxiosHookResponse, useAxiosGetRequest } from 'app-shared/lib/api/utils/axios-request.hooks';
import { API_COMMON_BASE_URL } from 'app-shared/lib/api/utils/api.constants';
import { SUGGESTIONS_URL } from './suggestion.constants';
import { PRODUCTS_URL } from '../product.constants';

/**
 * Get shop products api
 */
export const getShopProductsSuggestions = (
  id: number,
  shopProductCategoryId?: number,
  isSuggestedInBag?: boolean
): Promise<AxiosResponse<number[]>> => {
  const url = `${API_COMMON_BASE_URL}/${CATALOG_SHOPS_URL}/${id}/${PRODUCTS_URL}/${SUGGESTIONS_URL}`;
  const config: AxiosRequestConfig = {
    params: {
      shopProductCategoryId,
      isSuggestedInBag,
    },
  };

  return axios.get(url, config);
};

/**
 * Get shop products api hook
 */
export const useGetShopProductsSuggestions = (id: number): AxiosHookResponse<void, number[]> => {
  const urlOptional = id
    ? `${API_COMMON_BASE_URL}/${CATALOG_SHOPS_URL}/${id}/${PRODUCTS_URL}/${SUGGESTIONS_URL}`
    : null;

  return useAxiosGetRequest(urlOptional);
};
